import {
    AssetCategoryFormData,
    AssetFormData,
    IAllocateAssetData,
    IAllocateAssetsFormData
} from "../type/asset-category.types";
import server from "../../../../server";
import Locale from "../../../../core/locale/locale";
import dayjs from "dayjs";

export function assetCategoryModalMapper(data: AssetCategoryFormData) {
    return {
        id: data.id,
        name: data.name,
        description: data.description,
    }
}

export function assetModalMapper(data: AssetFormData) {
    return {
        id: data.id,
        assetCode: data.assetCode,
        brandName: data.brandName,
        purchaseDate: data.purchaseDate ? dayjs(data.purchaseDate).format(Locale.dateFormat) : null,
        purchaseCost: data.purchaseCost ? Number(data.purchaseCost) : null,
        warrantyDate: data.warrantyDate ? dayjs(data.warrantyDate).format(Locale.dateFormat) : null,
        isReturnable: data.isReturnable,
        manufacturingDate: data.manufacturingDate ? dayjs(data.manufacturingDate).format(Locale.dateFormat) : null,
        specification: data.specification,
        comments: data.comments,
        status: data.status,
    }
}

export function allocateAssetModalMapper(data: IAllocateAssetsFormData) {
    return data.assets.map((item: IAllocateAssetData) => ({
        categoryId: item.categoryId,
        assetId: item.assetId,
        expectedReturnDate: data.expectedReturnDate
            ? dayjs(data.expectedReturnDate).format(Locale.dateFormat)
            : null,
        adminRemarks: data.adminRemarks
    }));
}

export async function categoryList() {
    const response = await server.asset.category.list();
    return response;
}

export async function createCategory(payload: AssetCategoryFormData) {
    const response = await server.asset.category.create(payload)
    return response
}

export async function updateCategory(id: string, payload: AssetCategoryFormData) {
    await server.asset.category.update(id, payload);
}

export async function createAsset(payload: any) {
    const response = await server.asset.create(payload)
    return response
}

export async function assetSearch(pageNumber?: any, pageSize?: any, payload?: any) {
    const response = await server.asset.search(pageNumber, pageSize, payload);
    return response;
}

export async function updateAsset(id: string, payload: AssetFormData) {
    await server.asset.update(id, payload);
}

export async function assetStatusUpdate(id: string, status: string) {
    await server.asset.statusUpdate(id, status);
}
